import React from "react";
import InputLabel from "../input/InputLabel";
import "./RadioButton.scss";
import classnames from "classnames";
import { withDefaults } from "../../utils/withDefaults";
import type { Placement } from "@popperjs/core";

export const RADIO_BUTTON_ORIENTATIONS = {
  VERTICAL: "vertical",
  HORIZONTAL: "horizontal"
} as const;

export type RadioButtonOrientation =
  (typeof RADIO_BUTTON_ORIENTATIONS)[keyof typeof RADIO_BUTTON_ORIENTATIONS];

export interface RadioButtonProps {
  label?: string;
  choices?: string[];
  name?: string;
  onSelection?: (choice: string) => void;
  value?: string;
  orientation?: RadioButtonOrientation;
  /** One ref per choice, in order; shorter arrays leave later inputs unref'd. */
  references?: (React.Ref<HTMLInputElement> | null)[];
  autoFocusFirstInput?: boolean;
  helpText?: string;
  helpTextPlacement?: Placement;
  required?: boolean;
}

export default function RadioButton(incomingProps: RadioButtonProps) {
  const props = withDefaults(incomingProps, radioButtonDefaultProps);

  return (
    <div className="radio-button-input">
      {props.label ? (
        <InputLabel
          label={props.label}
          helpText={props.helpText}
          helpTextPlacement={props.helpTextPlacement}
          isRequired={props.required}
        />
      ) : null}
      <div className={classnames("radio-button-choices", props.orientation)}>
        {props.choices.map((choice, index) => {
          return (
            <div key={index} className="radio-button">
              <input
                type="radio"
                id={choice.toLowerCase()}
                value={choice}
                name={props.name}
                checked={props.value === choice}
                onChange={() => props.onSelection(choice)}
                autoFocus={props.autoFocusFirstInput && index === 0}
                ref={
                  props.references.length > index
                    ? props.references[index]
                    : null
                }
              />
              <label htmlFor={choice.toLowerCase()}>{choice}</label>
              <br />
            </div>
          );
        })}
      </div>
    </div>
  );
}

const radioButtonDefaultProps = {
  label: "",
  choices: [] as string[],
  name: "",
  onSelection: () => {},
  value: "",
  orientation: RADIO_BUTTON_ORIENTATIONS.VERTICAL,
  references: [] as (React.Ref<HTMLInputElement> | null)[],
  autoFocusFirstInput: false
};
